import Common from '../../../Common';

export type BrowseSIM = {
	id: number
	KundID: number
	Förnamn: string
	Efternamn: string
	Adress: string
	Adress2: string
	Postnr: string
	Ort: string
	Land: string
	EMail: string
	Telefon1: string
	KreditLimit: number
	cdr_mobile_prices_id: 1 | 0
	added: string
	pause_date?: string
	start_date: string
	NummerUpplysning: boolean
	shared_data_KundPersonID: number
	allowed_to_topup: boolean
	ucCompanyUser?: string
	billingE164?: string
	KunderCostCenterId: number
	SimNo: number
	SimStatus: 1 | 0
	e164: number
	writeLock: boolean
	selfservice_pricelist_id?: string
	item_locked?: string
}

export type AvailableSIM = {
	id: number
	SimNo: number
	ProdMSISDN: number
}

const SIM = class extends Common {
	available = (companyId: id): CustomResponse<AvailableSIM[]> =>
		this.get(`/company/${companyId}/selfservice/sim/available`)

	browse = (companyId: id): CustomResponse<BrowseSIM[]> =>
		this.get(`/company/${companyId}/selfservice/sim`)
}

export default SIM
